import {
  DEFAULT_REGISTER_RECENCY_PREFERENCES,
  REGISTER_SEARCH_MODES,
  sanitizeRegisterRecencyPreferences,
} from "./registerPreferences";

export const GROUPINGS_PREFERENCES_STORAGE_KEY =
  "vocabularium_groupings_preferences";

export const GROUPING_DETAIL_PANES = {
  LIST: "list",
  STATS: "stats",
};

export const DEFAULT_GROUPINGS_PREFERENCES = {
  ...DEFAULT_REGISTER_RECENCY_PREFERENCES,
  detailPane: GROUPING_DETAIL_PANES.LIST,
};

export const GROUPINGS_SEARCH_MODE_HELP = {
  [REGISTER_SEARCH_MODES.STARTS_WITH]:
    "En R, seuls les groupements dont le nom commence par votre saisie apparaissent. En M, ce sont les mots affiliés qui sont comparés ainsi.",
  [REGISTER_SEARCH_MODES.CONTAINS]:
    "En R, les groupements dont le nom contient votre saisie apparaissent. En M, ce sont les mots affiliés qui sont comparés ainsi.",
};

export function sanitizeGroupingsPreferences(raw) {
  const base = sanitizeRegisterRecencyPreferences(raw);
  return {
    ...base,
    detailPane:
      raw?.detailPane === GROUPING_DETAIL_PANES.STATS
        ? GROUPING_DETAIL_PANES.STATS
        : GROUPING_DETAIL_PANES.LIST,
  };
}

export function readGroupingsPreferences() {
  try {
    const stored = localStorage.getItem(GROUPINGS_PREFERENCES_STORAGE_KEY);
    if (!stored) return { ...DEFAULT_GROUPINGS_PREFERENCES };
    return sanitizeGroupingsPreferences(JSON.parse(stored));
  } catch {
    return { ...DEFAULT_GROUPINGS_PREFERENCES };
  }
}

export function writeGroupingsPreferences(preferences) {
  try {
    localStorage.setItem(
      GROUPINGS_PREFERENCES_STORAGE_KEY,
      JSON.stringify(sanitizeGroupingsPreferences(preferences))
    );
  } catch {
    // ignore quota errors
  }
}
